import { buildSummary } from "@/lib/reports";
import { regPaidByChurch } from "@/lib/registrations";

export const QUARTERS = ["Q1 (Jan–Mar)", "Q2 (Apr–Jun)", "Q3 (Jul–Sep)", "Q4 (Oct–Dec)"];
const qOf = (date) => Math.floor((Number(String(date).slice(5, 7)) - 1) / 3);
const total = (arr) => arr.reduce((a, b) => a + b, 0);

function quarterTable(title, label, list, keyOf, order = []) {
  const m = new Map(order.map((k) => [k, [0, 0, 0, 0]]));
  list.forEach((r) => {
    const k = keyOf(r) || "(none)";
    if (!m.has(k)) m.set(k, [0, 0, 0, 0]);
    m.get(k)[qOf(r.date)] += Number(r.amount || 0);
  });
  const body = [...m.entries()].map(([k, q]) => [k, ...q, total(q)]);
  const foot = ["TOTAL", ...[1, 2, 3, 4, 5].map((i) => body.reduce((a, row) => a + row[i], 0))];
  return { title, head: [label, ...QUARTERS, "Year Total"], body, foot, moneyCols: [1, 2, 3, 4, 5] };
}

export function annualSections({ scope, churches, tithes, donations, registrations = [], destNames, categoryNames, show, toggles = {} }) {
  const R = !!show.registrations;
  const rp = regPaidByChurch(registrations);
  const on = (k) => toggles[k] !== false;
  const rows = buildSummary({ churches, tithes, donations });
  const cname = Object.fromEntries(rows.map((r) => [r.id, r.name]));
  const order = rows.map((r) => r.name);
  const byChurch = (r) => cname[r.church_id] || r.church_name;
  const sections = [];
  const head = ["#", "Church", "State", ...(show.tithes ? [...destNames, "Tithe Total"] : []), ...(show.donations ? ["Conference Collection"] : []), ...(R ? ["Registrations (paid)"] : []), "Grand Total"];
  const body = rows.map((r, i) => [i + 1, r.name, r.state, ...(show.tithes ? [...destNames.map((d) => r.dest[d] || 0), r.tithe] : []), ...(show.donations ? [r.don] : []), ...(R ? [rp[r.id] || 0] : []), (show.tithes ? r.tithe : 0) + (show.donations ? r.don : 0) + (R ? rp[r.id] || 0 : 0)]);
  const foot = ["", "TOTAL", "", ...head.slice(3).map((_, j) => body.reduce((a, row) => a + Number(row[j + 3] || 0), 0))];
  if (on("totals_by_church")) sections.push({ title: "Annual Totals by Church", head, body, foot, moneyCols: head.map((_, i) => i).filter((i) => i >= 3) });
  if (show.tithes) {
    if (on("tithes_church_q")) sections.push(quarterTable("Tithes by Church and Quarter", "Church", tithes, byChurch, order));
    if (on("tithes_dest_q")) sections.push(quarterTable("Tithes by Destination and Quarter", "Sent to", tithes, (r) => r.destination, destNames));
  }
  if (show.donations) {
    if (on("donations_church_q")) sections.push(quarterTable("Conference Collection by Church and Quarter", "Church", donations, byChurch, order));
    if (on("donations_category_q")) sections.push(quarterTable("Conference Collection by Category and Quarter", "Category", donations, (r) => r.category, categoryNames));
  }
  if (!on("quarterly_totals")) return sections;
  const q = QUARTERS.map((label, i) => {
    const t = show.tithes ? tithes.filter((r) => qOf(r.date) === i).reduce((a, r) => a + Number(r.amount || 0), 0) : 0;
    const d = show.donations ? donations.filter((r) => qOf(r.date) === i).reduce((a, r) => a + Number(r.amount || 0), 0) : 0;
    const g = R ? registrations.filter((r) => r.paid && qOf(r.created_at) === i).reduce((a, r) => a + Number(r.fee_amount || 0), 0) : 0;
    return [label, ...(show.tithes ? [t] : []), ...(show.donations ? [d] : []), ...(R ? [g] : []), t + d + g];
  });
  const qHead = ["Quarter", ...(show.tithes ? ["Tithes"] : []), ...(show.donations ? ["Conference Collection"] : []), ...(R ? ["Registrations (paid)"] : []), "Total"];
  sections.push({ title: `Quarterly Totals (${String(scope).replace(/ \(\d+\)$/, "")})`, head: qHead, body: q, foot: ["YEAR TOTAL", ...qHead.slice(1).map((_, j) => q.reduce((a, row) => a + row[j + 1], 0))], moneyCols: qHead.map((_, i) => i).filter((i) => i > 0) });
  return sections;
}
